import { useState } from "react"
import styles from 'styles/Pager.module.css';

const Pager = ({ currentPage, totalPages, handlePageClick }: { currentPage: number, totalPages: number; handlePageClick: (page: number) => void }) => {
  return (
    <div className={styles["page-button-container"]}>
      {Array.from({ length: totalPages }, (_, index) => {
        const page = index + 1;
        return (
          <button
            key={page}
            className={`${styles["page-button"]} ${
              currentPage === page ? styles["active"] : ""
            }`}
            onClick={() => handlePageClick(page)}
            style={{
              color: currentPage === page ? "#bf0178" : "#333",
              border: currentPage === page ? "1.5px solid #bf0178" : "1.5px solid #333",
            }}
          >
            {page}
          </button>
        );
      })}
    </div>
  );
};

export default Pager;
